export enum AdminWSCommands {
  ROOM_STATS = 'getRoomStats',
  ROOM_STATS_RES = 'returnRoomStats',
  FORCE_STAGE_ITEMS_UPDATE = 'forceStageItemsUpdate',
}
